export class NodeDeviceListElement extends HTMLElement {
    #client;
    set client(value) {
        this.#client = value;
        if (this.isConnected)
            void this.#load();
    }
    get client() { return this.#client; }
    connectedCallback() { void this.#load(); }
    async #load() {
        if (this.#client === undefined)
            return;
        this.textContent = "Loading devices…";
        try {
            this.#render(await this.#client.command("client-device.list.v1", { includeRevoked: true }));
        }
        catch (error) {
            this.textContent = error instanceof Error ? error.message : "Devices could not be loaded";
            this.setAttribute("role", "alert");
        }
    }
    #render(devices) {
        this.replaceChildren();
        const heading = document.createElement("h2");
        heading.textContent = "Client devices";
        const list = document.createElement("ul");
        for (const device of devices) {
            const item = document.createElement("li");
            const name = document.createElement("input");
            name.setAttribute("aria-label", `Name for ${device.deviceName}`);
            name.value = device.deviceName;
            const status = document.createElement("span");
            status.textContent = `${device.deviceType} · ${device.status}`;
            const rename = document.createElement("button");
            rename.type = "button";
            rename.textContent = "Rename";
            rename.addEventListener("click", () => void this.#rename(device.id, name.value));
            const revoke = document.createElement("button");
            revoke.type = "button";
            revoke.textContent = "Revoke";
            revoke.disabled = device.status === "revoked";
            revoke.addEventListener("click", () => void this.#revoke(device.id));
            item.append(name, status, rename, revoke);
            list.append(item);
        }
        this.append(heading, list);
    }
    async #rename(id, deviceName) {
        if (this.#client === undefined || deviceName.trim() === "")
            return;
        await this.#client.command("client-device.rename.v1", { deviceName: deviceName.trim(), id });
        await this.#load();
    }
    async #revoke(id) {
        if (this.#client === undefined)
            return;
        try {
            await this.#client.command("client-device.revoke.v1", { id });
            await this.#load();
        }
        catch (error) {
            const message = error instanceof Error ? error.message : "Device could not be revoked";
            if (message.toLowerCase().includes("revoked")) {
                this.dispatchEvent(new Event("client-device-revoked", { bubbles: true, composed: true }));
                return;
            }
            this.textContent = message;
            this.setAttribute("role", "alert");
        }
    }
}
//# sourceMappingURL=device-list.js.map